export const UNFILLED_STATES = {
  pending: "pending",
  shortlisting: "shortlisting",
  reviewing: "reviewing",
  inviting: "inviting",
  partially_confirmed: "partially_confirmed",
  partially_booked: "partially_booked",
  partially_filled: "partially_filled"
};

export const FILLED_STATES = {
  confirmed: "confirmed",
  filled: "filled",
  booked: "booked"
};

export const WORKFLOW_STATES = {
  ...UNFILLED_STATES,
  ...FILLED_STATES
};

export const AUTOMATION_STATES = {
  auto_shortlisting: "auto_shortlisting",
  auto_filling: "auto_filling"
};

export const ALL_WORKFLOW_STATES = {
  ...WORKFLOW_STATES,
  ...AUTOMATION_STATES
};
